import { Link } from 'react-router-dom'
import { impressumData } from '../../impressum/index'
import styles from './SiteFooter.module.css'

export default function SiteFooter() {
  const { publicationName, email, copyrightYear } = impressumData

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <span>{publicationName}</span>
        <span className={styles.separator}>·</span>
        <a className={styles.link} href={`mailto:${email}`}>{email}</a>
        <span className={styles.separator}>·</span>
        <span>© {copyrightYear} {publicationName}</span>
        <span className={styles.separator}>·</span>
        <Link className={styles.link} to="/impressum">Impressum</Link>
        <span className={styles.separator}>·</span>
        <Link className={styles.link} to="/privacy">Privacy Notice</Link>
      </div>
    </footer>
  )
}
